/**
 * Helpers shared by the bq-* scripts, loaded ahead of them so `window.bq` exists
 * when they run. Consumers still check for it and bail: a stale cache can serve
 * one without this, and a missing escapeHTML must never mean unescaped output.
 */
(function () {
  'use strict';
  var bq = (window.bq = window.bq || {});

  bq.escapeHTML = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  // Recombines a tone rendered as a spacing character after the vowel ("uˇ").
  bq.fixPinyin = function (s) {
    if (!s) return s;
    var MAP = { 'ˉ': '̄', '¯': '̄', 'ˊ': '́', '´': '́', 'ˇ': '̌', 'ˋ': '̀' };
    return s.replace(/([aeiouüAEIOUÜ]) ?([ˇˉˊˋ¯´])/g, function (_, v, mark) {
      return v + (MAP[mark] || '');
    }).normalize('NFC');
  };

  // Parentheses holding an ideograph or a toned vowel get the font that covers them,
  // "(Xiǎoshǔ)" having no 汉字 and otherwise losing its third tones to a fallback face.
  bq.wrapPinyin = function (html) {
    return String(html).replace(/\([^()]*[一-鿿ĀāĒēĪīŌōŪūǍ-ǜ][^()]*\)/g, function (m) {
      return '<span class="bq-pinyin">' + m + '</span>';
    });
  };

  // Whitespace is left as found: the name index collapses it itself and the
  // highlighter normalizes character by character to keep its position map aligned.
  bq.norm = function (s) {
    s = (s == null ? '' : String(s)).toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s;
  };

  bq.slug = function (s) {
    return bq.norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  };

  bq.reducedMotion = function () {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  };

  // Low-end or metered: callers run one static frame instead of animating.
  bq.liteDevice = function () {
    try {
      return (navigator.deviceMemory && navigator.deviceMemory <= 4) ||
        (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
        (navigator.connection && navigator.connection.saveData === true) || false;
    } catch (e) { return false; }
  };

  // Locale prefix ('/', '/en/'): an unprefixed storefront fetch answers in the
  // shop's primary language. `el` supplies data-root as the fallback.
  bq.root = function (el) {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) ||
      (el && el.dataset && el.dataset.root) || '/';
    return String(r).replace(/\/*$/, '/');
  };

  // The Nuwa launcher is rendered at the end of body, so wire on a whole DOM.
  bq.wireNuwa = function (root, sel) {
    var btn = root && root.querySelector(sel);
    if (!btn) return;
    var wire = function () {
      var launcher = document.querySelector('.bq-orienteur__launcher');
      if (!launcher) return;
      btn.hidden = false;
      btn.addEventListener('click', function () { launcher.click(); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire, { once: true });
    else wire();
  };
})();
